import { Controller } from "@hotwired/stimulus"

// Handles click-to-set focal point on image thumbnails
export default class extends Controller {
  static targets = ["imageArea", "indicator", "coordinates", "inputX", "inputY",
                     "horizontalGuide", "verticalGuide"]
  static values = {
    x: { type: Number, default: 0.5 },
    y: { type: Number, default: 0.5 }
  }

  connect() {
    this.updateDisplay()
  }

  setPoint(event) {
    const rect = this.imageAreaTarget.getBoundingClientRect()
    const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width))
    const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height))

    this.xValue = Math.round(x * 1000) / 1000
    this.yValue = Math.round(y * 1000) / 1000

    this.updateDisplay()
    this.dispatchChange()
  }

  xValueChanged() {
    this.updateDisplay()
  }

  yValueChanged() {
    this.updateDisplay()
  }

  updateDisplay() {
    const xPercent = (this.xValue * 100).toFixed(1)
    const yPercent = (this.yValue * 100).toFixed(1)

    // Update indicator position
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.style.left = `${xPercent}%`
      this.indicatorTarget.style.top = `${yPercent}%`
    }

    // Update coordinates text
    if (this.hasCoordinatesTarget) {
      this.coordinatesTarget.textContent = `(${xPercent}%, ${yPercent}%)`
    }

    // Update hidden inputs
    if (this.hasInputXTarget) {
      this.inputXTarget.value = this.xValue
    }
    if (this.hasInputYTarget) {
      this.inputYTarget.value = this.yValue
    }

    // Update crosshair guides
    if (this.hasHorizontalGuideTarget) {
      this.horizontalGuideTarget.style.top = `${yPercent}%`
      this.horizontalGuideTarget.classList.remove("hidden")
    }
    if (this.hasVerticalGuideTarget) {
      this.verticalGuideTarget.style.left = `${xPercent}%`
      this.verticalGuideTarget.classList.remove("hidden")
    }
  }

  dispatchChange() {
    this.dispatch("changed", {
      detail: { x: this.xValue, y: this.yValue }
    })
  }

  reset() {
    this.xValue = 0.5
    this.yValue = 0.5
    this.updateDisplay()
    this.dispatchChange()
  }
}
